

























import { Vue, Prop, Component } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import { FileDiskSpace as IFileDiskSpace } from "@/api/models/file-disk-space";
import { isRoot } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";
import FileManager from "@/components/files/FileManager.vue";
import CFileManager from "@/components/fileManager/CFileManager.vue";
@Component({
  components: { CFileManager, FileManager, CustomButton }
})
export default class UserProfileSpace extends Vue {
  @Prop() userInfo!: IUser;
  userSpace!: IFileDiskSpace;
  isOpenFileManager: boolean = false;
  data() {
    return {
      userCompanies: undefined,
      userSpace: undefined
    };
  }

  get screenWidth() {
    return window.innerWidth;
  }

  getFileSizeFormatter(bytes: number, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  get root() {
    return isRoot();
  }
}
